enum PriceUpchargeTypeEnum {
    FIXED = 1,
    PERCENT,
}

export default PriceUpchargeTypeEnum;
